module.exports = __webpack_public_path__ + "static/media/benz-12.d821d3bd.jpg";